import React from 'react';
import { useAppContext } from '../../context/AppContext.tsx';
import { MinUserAvatar } from '../../UIComponents/UserAvatar.ts';


const UserCell = ({ userId, exUI }) => {
    const { dimensions, allUsers } = useAppContext();
    const myUser = ((userId == null || userId == 0)) ? null : allUsers?.find((x) => x.userID == userId)?.userName;
    return (
        myUser != null &&
        <span className={typeof exUI != 'undefined' ? 'd-flex flex-row align-items-start gap-1' : 'd-flex flex-row align-items-center gap-1'}>
            <MinUserAvatar>
                {myUser == null ? "NA" : myUser?.charAt(0).toUpperCase()}
            </MinUserAvatar>
            <div className='d-flex flex-column' style={{ lineHeight: "16px" }}>
                {
                    myUser
                }
                {
                    exUI
                }
            </div>
        </span>
    );
};

export default UserCell;
